import { useUser } from "../../functional-components/UserContext";

const UserData = () => {
  const { user, admin } = useUser();
  return user
    ? (user.displayName || user.email) + " " + (admin ? " (Admin)" : "")
    : null;
};

export default UserData;
